import React from 'react';
import ReactSelect from 'react-select';
import R from '../../lib/constants/R';
import PropTypes from '../../lib/utils/propTypes';

export const Select = ({ options, fieldName, size, ...rest }) => (
	<div className="form w-100">
		<ReactSelect
			fullWidth={true}
			options={options}
			noOptionsMessage={() => 'Sem opções'}
			getOptionLabel={option => option[fieldName]}
			getOptionValue={option => option.id}
			styles={{
				control: (base, state) => ({
					...base,
					'width': size ? size + 'px' : null,
					'&:hover': { borderColor: 'none' },
					border: state.isFocused
						? `1px solid black`
						: '1px solid black',
					boxShadow: state.isFocused
						? `0px 0px 5px${R.colors.colorPrimary}`
						: 0,
				}),
			}}
			{...rest}
		/>
	</div>
);

Select.propTypes = {
	options: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
	fieldName: PropTypes.string,
};

Select.defaultProps = {
	options: [],
	fieldName: 'name',
};

export default Select;
